/**
 * 사업자 정보 설정 키
 * Setting 테이블에서 사용되는 키-값 쌍
 */
export const BusinessInfo = {
  // 회사 정보
  pigbank_company_name: '회사명',
  pigbank_ceo_name: '대표자명',
  pigbank_business_number: '사업자등록번호',
  pigbank_commerce_number: '통신판매업 신고번호',
  pigbank_address: '주소',
  pigbank_address_detail: '상세주소',
  pigbank_contact: '대표전화',
  pigbank_email: '이메일',

  // 계좌 정보
  pigbank_bank_name: '은행명',
  pigbank_account_number: '계좌번호',
  pigbank_account_holder: '예금주',
} as const;

export type BusinessInfoKey = keyof typeof BusinessInfo;
export type BusinessInfoValue = (typeof BusinessInfo)[BusinessInfoKey];

/**
 * 값으로 키를 찾는 유틸리티 함수
 */
export function fnGetKeyByValue(
  obj: typeof BusinessInfo,
  value: BusinessInfoValue
): BusinessInfoKey | undefined {
  return (Object.keys(obj) as BusinessInfoKey[]).find(
    key => obj[key] === value
  );
}
